export class Guid {

    /**
     * Generate a code which matches a GUID.
     * 
     * @returns a generated GUID.
     */
    static newGuid() : string {
      return this.generate('xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx');
    }

    /**
     * Generate a code.
     * 
     * @param size the number of digits. Anything less than 4 has no effect.
     * @returns a generated code of at least 4 digits.
     */
    static generateCode(size : number) : string {

      var pattern = "xxxx";

      if (size) {
        if (size < 0) {
          size = (size * -1)
        }

        size = Math.ceil(size);

        pattern = pattern.padEnd(size,'x');
      }

      return this.generate(pattern);
    }

    /**
     * Generate a code from the pattern.
     * 
     * @param pattern a string pattern made where 'x' and 'y' characters will be replaced with a random.
     * @returns a generated code.
     */
    static generate(pattern : string) : string {
      return ('' + pattern).replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });      
    }
  }